export default "__VITE_ASSET__CXIipaGR__"